import React from 'react';
import HomeLayout from './HomeLayout';
import { HOMEPAGE_FAQ } from '../common/constants';

const FaqLayout = props => {
    return <HomeLayout {...props} subPage={HOMEPAGE_FAQ} />;
};

export default FaqLayout;
